import { gql } from "@apollo/client";

export const EDITAR_PERIODO = gql`
    mutation UpdatePeriodo($input: EditPeriodoInput!){
    updatePeriodo(
       input: $input
    ) {
        idPeriodo
    }
}
`;